<template>
  <MonitorWrapper class="rg05">
    <el-row :gutter="20">
      <el-col :span="24">
        <info-block :title="[deviceName, sn]">
          <template #titleRight>
            <!-- <span>设备电量：{{ powerPercent }}%</span> -->
            <div style="display: flex; justify-content: flex-end">
              <el-button
                type="text"
                v-if="!isHisDetail && authMenu['01042603']"
                @click="setDeviceAnalogAarm"
              >
                {{ $t('报警演练') }}
              </el-button>
              <el-button
                type="text"
                v-if="!isHisDetail && authMenu['01042602']"
                @click="toNuclideSetting"
              >
                {{ $t('核素设置') }}
              </el-button>
              <el-button type="text" v-if="!isHisDetail && authMenu['01042601']" @click="toSetting">
                {{ $t('设置') }}
              </el-button>
            </div>
          </template>
          <template #content>
            <el-row class="rg05-info state-block">
              <el-col :span="8">
                <ModsIcon
                  showText
                  :alarmState="alarmState"
                  :alarmDic="alarm"
                  width="120px"
                  icon="icon-he"
                  :wsData="wsData"
                  :mods="curMod"
                />
              </el-col>
              <el-col :span="8">
                <div>
                  <span>{{ $t('温度') }}:</span>
                  <span>{{ temp }}°</span>
                </div>
                <div>
                  <span>{{ $t('湿度') }}:</span>
                  <span>{{ humidity }}%RH</span>
                </div>
                <div :class="batteryCapacity >= 20 ? '' : 'battery-alarm'">
                  <span>{{ batteryCapacity >= 20 ? '' : $t('低') }}{{ $t('电量') }}:</span>
                  <span>{{ batteryCapacity }}%</span>
                </div>
                <div>
                  <span>{{ $t('核素名称') }}:</span>
                  <span>{{ nuclideName }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <span>{{ $t('射线本底数') }}(CPS):</span>
                  <span>{{ bgroundValue }}</span>
                </div>
                <div>
                  <span>{{ $t('射线实时数') }}(CPS):</span>
                  <span>{{ realValue }}</span>
                </div>
                <div>
                  <span>{{ $t('红外计数') }}:</span>
                  <span>{{ infraredCount }}</span>
                </div>
                <div>
                  <span>{{ $t('报警状态') }}:</span>
                  <span :style="{ color: alarmColor }">
                    {{ alarmState | alarmText | translateTo(i18nPath) }}
                  </span>
                </div>
              </el-col>
            </el-row>
            <div class="rg05-chart" style="overflow: hidden">
              <v-chart :options="leftOp" :autoresize="true"></v-chart>
            </div>
          </template>
        </info-block>
      </el-col>
    </el-row>
  </MonitorWrapper>
</template>

<script>
import { mapState } from 'vuex';
import InfoBlock from '../components/info-block';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/views/realdata/FCBR-100/options';
import ModsIcon from '@/components/mods-icon';
import monitorMixin from '@/mixins/monitorMixin';
import { popRG05Setting, popRG05NuclideSetting } from '@/layout/mainHeader/util';
import { setDeviceAnalogAarm } from '@/layout/commonActions/setDeviceAnalogAarm';

export default {
  name: 'RMS-C',
  components: {
    InfoBlock,
    ModsIcon
  },
  mixins: [monitorMixin],
  filters: {
    alarmText(state) {
      const dict = ['正常', '数值报警', '电量报警', '故障报警', '核素报警'];
      return dict[state] || '';
    }
  },
  data() {
    return {
      i18nPath: 'device',
      alarm: ['正常', '数值报警', '电量报警', '故障报警', '核素报警'],
      rg05: null,
      nuclideName: '--',
      nuclideTimer: null,
      delay: 10000,
      leftOp: lineAreaStyle({
        legend: {
          right: 10,
          orient: 'vertical',
          align: 'left',
          icon: 'rect',
          textStyle: {
            color: '#fff'
          }
        },
        yAxis: { name: 'CPS' },
        color: ['#06c9c3', '#7a17c7'],
        series: [
          {
            name: '射线本底数',
            areaStyle: { color: graColor('rgba(6, 201, 195, .8)', 'rgba(6, 201, 195, 0.1)') }
          },
          {
            name: '射线实时数',
            type: 'line',
            symbolSize: 10,
            smooth: true,
            data: [],
            areaStyle: { color: graColor('rgba(122, 23, 199, .8)', 'rgba(122, 23, 199, 0.1)') }
          }
        ]
      }),
      wsData: {},
      curMod: 'nuclearMod'
    };
  },
  computed: {
    ...mapState('history', ['historyDetailData', 'historyDetailDatas']),
    alarmState() {
      return this.rg05 ? this.rg05.alarmState : 0;
    },
    // powerPercent() {
    //   return this.rg05 ? this.rg05.powerPercent : 0;
    // },
    alarmColor() {
      return this.alarmState !== 0 ? '#FF4847' : '#03b36e';
    },
    realValue() {
      return this.rg05 ? this.rg05.cpsValue : 0;
    },
    bgroundValue() {
      return this.rg05 ? this.rg05.cpsBaselineValue : 0;
    },
    infraredCount() {
      return this.rg05 ? this.rg05.infraredCount : 0;
    },
    deviceName() {
      return this.deviceSNMap[this.sn]?.name;
    },
    batteryCapacity() {
      return this.rg05 ? this.rg05.batteryCapacity : 0;
    },
    temp() {
      return this.rg05 ? this.rg05.temp : 0;
    },
    humidity() {
      return this.rg05 ? this.rg05.humidity : 0;
    },
    authMenu() {
      return this.$store.state.admin.authMenu;
    }
  },
  methods: {
    langChangeHandler() {
      this.leftOp.series[0].name = this.$t('射线本底数');
      this.leftOp.series[1].name = this.$t('射线实时数');
    },
    toSetting() {
      popRG05Setting({ sn: this.sn, deviceType: this.deviceType });
    },
    setDeviceAnalogAarm() {
      setDeviceAnalogAarm({ container: this.$el, sn: this.sn, deviceType: this.deviceType });
    },
    toNuclideSetting() {
      popRG05NuclideSetting({ sn: this.sn, deviceType: this.deviceType });
    },
    updateData(newVal) {
      const { beginTime } = newVal;
      const { rg05, nuclideName } = newVal.mods[this.curMod];

      if (!rg05) {
        this.nuclideName = nuclideName;
        clearTimeout(this.nuclideTimer);
        this.nuclideTimer = setTimeout(() => {
          this.nuclideName = '--';
        }, this.delay);

        return;
      }

      this.wsData = newVal;

      this.rg05 = rg05;
      this.leftOp.series[0].data.push([beginTime, rg05.cpsBaselineValue]);
      this.leftOp.series[1].data.push([beginTime, rg05.cpsValue]);
      if (this.leftOp.series[0].data.length > 20) {
        this.leftOp.series[0].data.shift();
        this.leftOp.series[1].data.shift();
      }
    },
    updateHisData() {
      this.historyDetailDatas.slice(-20).forEach(val => {
        this.updateData(val);
      });
      clearTimeout(this.nuclideTimer);
      this.wsData = this.historyDetailData;
      this.rg05 = this.historyDetailData.mods[this.curMod].rg05;
      this.hideLoading();
    }
  },
  created() {
    this.langChangeHandler();
  }
};
</script>

<style lang="scss" scoped>
.rg05 {
  height: 100%;

  .battery-alarm {
    color: $danger-color;
  }

  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      .rg05-info {
        height: 35%;
        &.state-block {
          .el-col {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            &:nth-child(2),
            &:nth-child(3) {
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              font-size: 18px;
              line-height: 34px;

              div {
                span:nth-of-type(1) {
                  margin-right: 8px;
                }
              }
            }
          }
        }
      }
      .rg05-chart {
        height: 65%;
      }
    }
  }
  .state {
    @include state-textstyle;
  }
}
</style>
